import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { styled, useTheme } from '@mui/material/styles';
import { BottomNavigationBar, Sidebar } from './nav';
import NavBar from './cometeLink/Navbar';
import { OFFLINE_BANNER_HEIGHT } from '../OfflineBanner';
import { MHidden } from '../@material-extend';

import useAppState from '../../hooks/useAppState';
import useCollapseDrawer from '../../hooks/useCollapseDrawer';

const PADDING_TOP = 72;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  // minHeight: '100vh', // waiting for global layout patterns
  overflow: 'hidden'
});

// `offlineOffset` (en px) compense la hauteur du bandeau hors-ligne quand il
// est inséré dans la Navbar (cf. cometeLink/Navbar). Centralisé ici pour
// éviter de redéfinir paddingTop dans le sx du composant — sm/md/lg avaient
// la même valeur, donc la cascade CSS suffit (md/lg n'ont besoin que des
// paddings latéraux et bottom).
const MainStyle = styled('div', {
  shouldForwardProp: (prop) => prop !== 'offlineOffset'
})(({ theme, offlineOffset = 0 }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: PADDING_TOP + offlineOffset,
  [theme.breakpoints.up('sm')]: {
    paddingTop: PADDING_TOP + 24 + offlineOffset,
    paddingBottom: theme.spacing(1)
  },
  [theme.breakpoints.up('md')]: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5)
  },
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}));

const LayoutCometeLink = () => {
  const theme = useTheme();
  const { collapseClick } = useCollapseDrawer();
  const { isOnline } = useAppState();
  const [open, setOpen] = useState(false);

  // Quand on est offline, le bandeau est rendu DANS l'AppBar au-dessus du
  // breadcrumb (cf. cometeLink/Navbar). L'AppBar grandit donc de la hauteur
  // du bandeau — on compense le paddingTop du contenu pour qu'il ne se cache
  // pas derrière.
  const offlineOffset = isOnline ? 0 : OFFLINE_BANNER_HEIGHT;

  return (
    <RootStyle className="comete-link-root">
      <NavBar onOpenSidebar={() => setOpen(true)} />

      <MHidden width="smDown">
        <Sidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      </MHidden>

      <MHidden width="smUp">
        <BottomNavigationBar />
      </MHidden>

      <MainStyle
        className="comete-link-main"
        offlineOffset={offlineOffset}
        sx={{
          marginTop: 'env(safe-area-inset-top) !important',
          marginBottom: window.env.isIos ? 0 : 'env(safe-area-inset-bottom) !important',
          overflow: 'auto',
          transition: theme.transitions.create('margin', {
            duration: theme.transitions.duration.complex
          }),
          ...(collapseClick && { ml: '102px' })
        }}
      >
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
};

export default LayoutCometeLink;
